var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavNotificationNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1DC3E2E-03C0-457E-BD13-4D25E05DA0C1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -232.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 221.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavNotification",
    transform: "translate(18.000000, 232.000000)",
    fill: "#979598",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C13.302,3 14.401,3.838 14.815,5 L20,5 C21.103,5 22,5.896 22,7 L22,19 C22,20.103 21.103,21 20,21 L4,21 C2.897,21 2,20.103 2,19 L2,7 C2,5.896 2.897,5 4,5 L9.185,5 C9.599,3.838 10.698,3 12,3 Z M9.185,7 L4,7 L4,19 L20.001,19 L20,7 L14.815,7 C14.401,8.162 13.302,9 12,9 C10.698,9 9.599,8.162 9.185,7 Z M8,14 C9.841,14 11,15.159 11,17 L5,17 C5,15.159 6.159,14 8,14 Z M19,15 L19,17 L13,17 L13,15 L19,15 Z M8,9 C9.1045695,9 10,9.8954305 10,11 C10,12.1045695 9.1045695,13 8,13 C6.8954305,13 6,12.1045695 6,11 C6,9.8954305 6.8954305,9 8,9 Z M19,11 L19,13 L13,13 L13,11 L19,11 Z M12,5 C11.449,5 11,5.449 11,6 C11,6.551 11.449,7 12,7 C12.551,7 13,6.551 13,6 C13,5.449 12.551,5 12,5 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavNotificationNormal);
export default __webpack_public_path__ + "static/media/NavNotificationNormal.1fd9cb089a835556b50ac486830769c1.svg";
export { ForwardRef as ReactComponent };